import dynamic from "next/dynamic";

const TitleComponent = dynamic(() => import("./OurStoryBuilder/Title"));
const CopyComponent = dynamic(() => import("./OurStoryBuilder/Copy"));
const AssetComponent = dynamic(() => import("./OurStoryBuilder/Asset"));
const TimelineComponent = dynamic(() => import("./OurStoryBuilder/Timeline"));

const OurStoryBuilder = props => {
	return props.builder.map((block, i) => {
		switch (block.component) {
			case "cbTitle":
				return (
					<TitleComponent block={block} key={block.component + i} />
				);
			case "copy":
				return (
					<CopyComponent block={block} key={block.component + i} />
				);
			case "asset":
				return (
					<AssetComponent block={block} key={block.component + i} />
				);
			case "timeline":
				return (
					<TimelineComponent
						block={block}
						key={block.component + i}
					/>
				);
			case "":
				return;
		}
	});
};

export default OurStoryBuilder;
